import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import ReactTooltip from "react-tooltip";
import { Subscribe } from "unstated";

import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import { myGlobals, myUtilities } from "../../Utils";
import {
  InvoiceGridRow,
  InvoiceCompleteGridHeader,
  InvoiceCompleteGrid,
} from "./";

class InvoiceGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [0, 1, 2],
    };
    this.invoiceData = null;
    this.editPopupRef = React.createRef();
  }
  showViewMore = (data) => {
    const isPartialEnabled = data?.state?.partialPaymentEnabledForGuestPay === true;
    const isDisabled = isPartialEnabled && data?.state?.partialPayProceeded === true;
    return (
      <Row>
        <Col className="view-more-row-container">
          <button
            className="view-more-invoices-button"
            disabled={isDisabled}
            onClick={() => {
              if (isDisabled) return;
              if (this.invoiceData?.snapshotPartialPaymentState) {
                this.invoiceData.snapshotPartialPaymentState();
              }
              this.props.alterEditState(true);
            }}
          >
            {isPartialEnabled
              ? myUtilities.accountSpecificLanguage(
                  "InvoiceGrid.EditInvoices",
                  "Edit Invoices"
                )
              : myUtilities.accountSpecificLanguage(
                  "InvoiceGrid.ViewMore",
                  "View More"
                )}
          </button>
        </Col>
      </Row>
    );
  };

  showSampleInvoices = (data) => {
    let rows = new Array();
    if (!data.state.loading) {
      if (data.state.count >= 3) rows = [0, 1, 2];
      else if (data.state.count === 2) {
        rows = [0, 1];
      } else {
        rows = [0];
      }
      if (!this.state.set)
        this.setState({
          rows: rows,
          set: true,
        });
    } else rows = [0, 1, 2];
    const listItems = rows.map((index) => (
      <InvoiceGridRow
        fields={this.invoiceData.state.gridFields?.slice(0, 4)}
        key={index}
        index={index}
      />
    ));
    return listItems;
  };
  setInvoiceData = (data) => {
    this.invoiceData = data;
  };
  outerEditPopupClick = (evt) => {
  };
  showEditWindowPopup = (data, payData) => {
    const isPartialEnabled = data?.state?.partialPaymentEnabledForGuestPay === true;
    if (this.props.toshowEditWindow) {
      return (
        <Container
          ref={this.editPopupRef}
          className="view-more-popup-container"
          onClick={this.outerEditPopupClick}
        >
          <div>
            <div className="mainTableView">
              <InvoiceCompleteGridHeader
                key="showEditGrid"
                crossClick={() => {
                  if (isPartialEnabled && data.restorePartialPaymentSnapshot) {
                    data.restorePartialPaymentSnapshot();
                  }
                  this.props.alterEditState(false);
                }}
                fields={this.invoiceData.state.gridFields}
              />
              <div className="invoice-exclusion-grid-footer">
                <div>
                  <b>
                    <span>
                      {myUtilities.accountSpecificLanguagePlaceholders(
                        "InvoiceGrid.SelectedUpdates",
                        "{selctedInvoices} out of {totalInvocies} Selected Bills",
                        {
                          selctedInvoices: data.state.count,
                          totalInvocies: data.state.invoices.length,
                        }
                      )}
                    </span>
                    &nbsp;|&nbsp;
                    {myUtilities.accountSpecificLanguage(
                      "Header.totalamt",
                      "Total Amount"
                    )}
                    : {myGlobals.globalCurrencySymbol}{" "}
                    {myUtilities.toStringUtil(data.state.total, "total")}
                  </b>
                </div>
                <Button style={{ margin: "3px" }}
                  className="invoice-exclusion-grid-button"
                  onClick={() => {
                    // Trigger alert if any partial amount is invalid (empty, <=0, or > original)
                    if (isPartialEnabled && data.validatePayableAmountsOnApply && !data.validatePayableAmountsOnApply()) {
                      return;
                    }
                    // Trigger alert if reason code is missing
                    if (isPartialEnabled && data.validatePartialPaymentReasons && !data.validatePartialPaymentReasons()) {
                      return;
                    }
                    if (isPartialEnabled && myGlobals.isDiscountEnabled) {
                      const paymentMethodForDiscount = myGlobals.paymentMethod ? myGlobals.paymentMethod : "ach";
                      data.makeDiscountOrLateFeeCallForPaymentMethod(payData, paymentMethodForDiscount);
                    } else if (isPartialEnabled) {
                      data.applyPartialPaymentTotal();
                    }
                    if (data.editSnapshot) {
                      data.editSnapshot = null;
                    }
                    this.props.alterEditState(false);
                  }}
                  variant="secondary"
                >
                  {isPartialEnabled
                    ? myUtilities.accountSpecificLanguage(
                      "InvoiceGrid.Apply",
                      "Apply"
                    )
                    : myUtilities.accountSpecificLanguage(
                      "InvoiceGrid.Close",
                      "Close"
                    )}
                </Button>
              </div>
            </div>
          </div>
        </Container>
      );
    }
  };

  render() {
    return (
      <Subscribe to={[InvoiceDataContainer, PaymentDataContainer]}>
        {(data, payData) => (
          <Container
            id="invoice-grid-container-id"
            className="invoice-grid-container"
          >
            {this.setInvoiceData(data)}
            {this.showSampleInvoices(data)}

            {this.showViewMore(data)}
            {this.showEditWindowPopup(data, payData)}
          </Container>
        )}
      </Subscribe>
    );
  }

  componentDidUpdate() {
    let width = window.screen.width;
    if (myGlobals.currentTheme !== "trifectaTheme.css") {
      if (null !== this.state.rows && this.state.rows.length === 1) {
        document.getElementById("invoice-grid-container-id").style.height =
          "50px";
        document.getElementById(
          "invoice-grid-container-id"
        ).style.backgroundColor = "white";
        if (width > 576)
          document.getElementById(
            "invoice-grid-container-id"
          ).style.marginBottom = "70px";
      } else if (null !== this.state.rows && this.state.rows.length === 2) {
        document.getElementById("invoice-grid-container-id").style.height =
          "100px";
        if (width > 576)
          document.getElementById(
            "invoice-grid-container-id"
          ).style.marginBottom = "35px";
      }
    }
  }
}

export default InvoiceGrid;
